import { isAddressHeld } from '@/shared/layout/address-hold'

/**
 * Holds MSAL's redirects while something decides whether the page stays on this address, such as
 * Site Management moving it to the site's primary base URL. A sign-in started first would keep its
 * transaction in the sessionStorage of the address being left, and be lost.
 */
let allowed: Promise<void> = Promise.resolve()

/** Holds every redirect until the returned function is called. Never called, they wait for good. */
export function holdRedirects(): () => void {
  const released: Array<() => void> = []
  const hold = new Promise<void>((resolve) => {
    released.push(resolve)
  })
  allowed = Promise.all([allowed, hold]).then(() => undefined)
  return () => {
    released[0]?.()
  }
}

/** Resolves once nothing holds redirects. */
export function redirectsAllowed(): Promise<void> {
  return allowed
}

/**
 * Resolves when a sign-out may leave: at once on a page that holds its address, as a failed
 * sign-in's page and a sign-in link's page do, since the move to the primary address waits until
 * that page lets go and so cannot race the sign-out; otherwise once nothing holds redirects.
 */
export function signOutRedirectAllowed(): Promise<void> {
  return isAddressHeld() ? Promise.resolve() : allowed
}
